<template>
  <div class="content">
    <div class="container-fluid">
      <div class="row">
        <div class="col-12">
          <card class="strpied-tabled-with-hover">
            <template slot="header">
              <h4 class="card-title">Localizations</h4>
              <p class="card-category"></p>
              <button class="btn btn-info btn-fill float-right" id="show-modal" v-on:click="showAddModal()">Add
              </button>
            </template>
            <l-table-actions :actions="tableLocalizations.actions"
                             :columns="tableLocalizations.columns"
                             :data="tableLocalizations.data"
                             class="table-hover table-striped">
            </l-table-actions>
          </card>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <card class="strpied-tabled-with-hover">
            <template slot="header">
              <h4 class="card-title">Map</h4>
            </template>
            <div id="map" class="map" style="height: 400px"></div>
          </card>
        </div>
      </div>
    </div>

    <modal :height="600" name="modalLocalization">
      <div class="modalStyle">
        <h4 class="card-title" v-if="!this.localization.edit">Add localization</h4>
        <h4 class="card-title" v-if="this.localization.edit">Edit localization</h4>
        <form @submit="formLocalizationSubmit" id="formLocalization">
          <div class="form-group">
            <div class="col-md-12">
              <base-input id="name"
                          label="Name"
                          name="name"
                          placeholder="Name"
                          type="text"
                          v-model="localization.name">
              </base-input>
            </div>
          </div>
          <div class="form-group">
            <div class="col-md-12">
              <base-input id="city"
                          label="City"
                          name="city"
                          placeholder="City"
                          type="text"
                          v-model="localization.city">
              </base-input>
            </div>
          </div>
          <div class="form-group">
            <div class="col-md-12">
              <base-input id="latitude"
                          label="Latitude"
                          name="latitude"
                          placeholder="Latitude"
                          type="number"
                          step="0.000001"
                          v-model="localization.latitude">
              </base-input>
            </div>
          </div>
          <div class="form-group">
            <div class="col-md-12">
              <base-input id="longitude"
                          label="Longitude"
                          name="longitude"
                          placeholder="Longitude"
                          type="number"
                          step="0.000001"
                          v-model="localization.longitude">
              </base-input>
            </div>
          </div>

          <div class="form-group">
            <div class="col-md-12">
              <base-input id="description"
                          label="Description"
                          name="description"
                          placeholder="Description"
                          type="text"
                          v-model="localization.description">
              </base-input>
            </div>
          </div>
          <div class="buttonModal">
            <button class="btn btn-info btn-fill float-right" v-if="!this.localization.edit"
                    v-on:click="closeAddModal()">Add
            </button>
            <button class="btn btn-info btn-fill float-right" v-if="this.localization.edit"
                    v-on:click="closeAddModal()">Save
            </button>
          </div>
        </form>
      </div>
    </modal>

    <l-modal-question ref="modalQuestion" :is-admin="this.isAdmin"/>
  </div>
</template>

<script>


  import LTableActions from 'src/components/TableActions.vue'
  import LModalQuestion from 'src/components/Modal/ModalQuestion'
  import Card from 'src/components/Cards/Card.vue'
  import 'vue-datetime/dist/vue-datetime.css'
  import EventBus from "../../event-bus";
  import {centerOfPoints} from "../../tools/MapTools";

  const Vue = window.Vue;

  const tableColumnsAdmin = ['Id', 'Name', 'City', 'Latitude', 'Longitude', 'User', 'Devices'];
  const tableColumns = ['Id', 'Name', 'City', 'Latitude', 'Longitude', 'Devices'];
  const tableData = [{}];

  export default {
    name: "LocalizationsPage",
    components: {
      LTableActions,
      LModalQuestion,
      Card
    },
    data() {
      return {
        idAdmin: false,
        map: null,
        tableLocalizations: {
          columns: [...tableColumns],
          data: [...tableData],
          actions: [
            {
              icon: 'info',
              handler: this.detailsItem
            },
            {
              icon: 'edit',
              handler: this.editItem
            },
            {
              icon: 'trash-alt',
              handler: this.deleteLocalizationQuestion
            }
          ]
        },
        app: {
          colNum: 2,
          grids: Array.from({length: 5}, _ => 100 + 300 * Math.random())
        },

        localization: {
          id: '',
          name: '',
          city: '',
          description: '',
          latitude: 0.0,
          longitude: 0.0,
          edit: false
        }

      }
    },

    mounted() {
      this.isAdmin = localStorage.getItem('isAdmin') === 'true';

      if (this.isAdmin === true) {
        this.tableLocalizations.columns = tableColumnsAdmin;
      }

      EventBus.$emit('EVENT_PATHS', [["/#/localizations/list", 'Localizations']]);

      this.loadLocalizations();
    },
    methods: {
      updateValue(event) {
        const value = event.target.value;
        if (String(value).length <= 10) {
          this.amount = value
        }
        this.$forceUpdate()
      },

      increase() {
        this.colNum += 1;
      },
      decrease() {
        if (this.colNum > 1) {
          this.colNum -= 1;
        }
      },
      add() {
        this.grids.push(100 + 300 * Math.random());
      },
      remove() {
        this.grids.pop();
      },
      reset() {
        this.grids = Array.from({length: 5}, _ => 100 + 300 * Math.random());
      },

      initMap() {
        let center = centerOfPoints(this.tableLocalizations.data);

        this.map = L.map('map').setView([center.latitude, center.longitude], center.zoom);
        this.tileLayer = L.tileLayer(
          'https://cartodb-basemaps-{s}.global.ssl.fastly.net/rastertiles/voyager/{z}/{x}/{y}.png',
          {
            maxZoom: 18,
            attribution: '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>, &copy; <a href="https://carto.com/attribution">CARTO</a>',
          }
        );
        this.tileLayer.addTo(this.map);

        for(let i = 0; i < this.tableLocalizations.data.length; i++) {
          let data = this.tableLocalizations.data[i];
          if (data.latitude !== null && data.latitude > 0 &&
            data.longitude !== null && data.longitude > 0) {
            let market = L.marker([data.latitude, data.longitude]).addTo(this.map);
            market.bindPopup(data.name);
          }
        }
      },

      loadLocalizations() {
        this.$http.get('localization/list')
          .then(result => {
            this.tableLocalizations.data = result.data;
            this.initMap();
          }, error => {
            console.error(error);
          });
      },
      detailsItem(item) {
        this.$router.push('/localizations/details/' + item.id);
      },
      editItem(item) {
        console.info("Edit item " + item.id);

        this.$http.get('localization/' + item.id)
          .then(result => {
            console.info(result.data);
            this.localization = result.data;
            this.localization.edit = true;
            this.$modal.show('modalLocalization');
          }, error => {
            console.error(error);
          });
      },
      deleteItem(item) {
        this.$http.delete('localization/' + item.id)
          .then(result => {
            console.info("Success");
            this.loadLocalizations();
          }, error => {
            console.error(error);
          });
      },
      showAddModal() {
        this.localization.id = '';
        this.localization.name = '';
        this.localization.city = '';
        this.localization.description = '';
        this.localization.latitude = 0.0;
        this.localization.longitude = 0.0;
        this.$modal.show('modalLocalization');
      },
      closeAddModal() {
        this.$modal.hide('modalLocalization');
      },
      formLocalizationSubmit(e) {
        e.preventDefault();

        let url = 'localization';
        let method = this.$http.post;

        if (this.localization.edit) {
          url += '/' + this.localization.id;
          method = this.$http.put;
        }

        method(url, {
          'name': this.localization.name,
          'city': this.localization.city,
          'description': this.localization.description,
          'latitude': Number(this.localization.latitude),
          'longitude': Number(this.localization.longitude),
        }).then(result => {
          console.info("Success");
          this.loadLocalizations();
        }, error => {
          console.error(error);
        });
      },
      deleteLocalizationQuestion(item) {
        this.$refs.modalQuestion.openModalQuestion('Do you want to remove localization: ' + item.name,
          item, this.deleteItem);
      }
    }
  }

  function maxLengthCheck(object) {
    if (object.value.length > object.maxLength)
      object.value = object.value.slice(0, object.maxLength)
  }


</script>
<style scoped>
  .modalStyle {
    margin-top: 20px;
    margin-left: 20px;
    margin-right: 20px;
  }

  .buttonModal {
    margin-top: 30px;
    margin-right: 20px;
  }

  @Datetime {
    width: 700px;

  }
</style>
